import { useState } from "react";
import { ProporcoesSensacoes } from "../Capitulos/ProporcaoSensacoes";
import { Proporcoes } from "../Capitulos/ProporcaoSentimentos";
import { TotalSensacoes } from "../Capitulos/TotalSensacoes";
import { TotalSentimentos } from "../Capitulos/TotalSentimentos";
import { TabMenu } from "../TabMenu";



export function GraficosSession({queryState}) {
  const [index, setIndex] = useState(1);

  return (
    <>
    <TabMenu currentIndex={index} setIndex={setIndex} />
      <Proporcoes queryState={queryState} currentIndex={index}/>
      <ProporcoesSensacoes queryState={queryState} currentIndex={index}/>
      <TotalSentimentos queryState={queryState} currentIndex={index}/>
      <TotalSensacoes queryState={queryState} currentIndex={index}/>
    </>
  );
}
